export default __webpack_public_path__ + "static/media/Warning.401d9362.svg";